import styled from '@emotion/styled'

import { Markdown } from 'src/screens/match/assessments/assignment-list/assignment/expansion/resources/Markdown'
import type { ResourceVideo as ResourceVideoData } from 'src/graphql/types'
import { HostedVideo } from 'src/system/ui/video/HostedVideo'

export function ResourceVideo(props: { resource: ResourceVideoData }) {
  const { video } = props.resource
  const title = video.text
  return (
    <Container>
      <div>
        <Markdown>{title}</Markdown>
      </div>
      <HostedVideo
        id={props.resource.id}
        url={video.url}
        poster={video.poster}
        captions={video.captions}
        title={title}
      />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;

  > div {
    box-sizing: border-box;
    flex: 100%;

    @media (min-width: ${(props) => props.theme.d.breakpoints.sm}) {
      flex: 50%;
    }
  }
`
